import { ProgressHeaderWithPopup } from "../components/progressHeaderWithPopup.jsx";
import { HeadLogo } from "../components/headLogo.jsx";
import { LocationImageDisplay } from "../components/locationImageDisplay.jsx";
import { GameIntroHeader } from "../components/gameIntroHeader.jsx";
import { CheckMoreButtons } from "../components/checkMoreButtons.jsx";
import { ModeIndication } from "../components/modeIndication.jsx";

function MirrorShotView({
  drawingKey,
  pictureKey,
  images,
  onComplete,
  mode,
  title,
  currentStep,
  captured,
  showCameraButton,
  showNextButtons,
  onCameraClick,
  videoRef,
  capturedImageSrc,
}) {
  return (
    <div className="mirrorShot-layout">
      <HeadLogo />
      <ProgressHeaderWithPopup currentStep={currentStep} title={title} />
      <ModeIndication mode={mode} />
      <div className="mirrorShot-content">
        <GameIntroHeader
          title="Mirror Shot"
          description="Find the spot and match the shot!"
        />

        <div className="mirrorshot-centered-wrapper">
          <div className="mirrorshot-comparisons">
            {/* Reference image */}
            {images[pictureKey] && (
              <img
                className="mirrorshot-refImage"
                src={images[pictureKey]}
                alt="Reference"
              />
            )}

             {showCameraButton && (
            <div className="mirrorshot-buttons-container">
              <img src={images["icon_camera"]} onClick={onCameraClick} />
            </div>
          )}

            {/* Captured image or video preview */}
            {!captured ? (
              <video
                ref={videoRef}
                className="mirrorshot-captured-image"
                playsInline
                muted
              />
            ) : (
              <img
                className="mirrorshot-captured"
                src={capturedImageSrc}
                alt="Captured"
              />
            )}
          </div>

          {/* Camera button */}
         

          {/* Redo / Next buttons */}
          {showNextButtons && <CheckMoreButtons onNext={onComplete} />}
          {captured && (
            <div className="mirrorshot-comments">
              <div className="mirrorshot-feedback">Caught it from a cool angle—hope it works for you!</div>
            </div>
          )}
        </div>
      </div>

      <LocationImageDisplay imageKey={drawingKey} />
    </div>
  );
}

export { MirrorShotView };
